<template>
    <div>
        <h2 class="subtitle"> {{strings.contact}} </h2>
        <p class="separator"></p>
        <p class="">
            <font-awesome-icon class="subtitle icon" icon="envelope"></font-awesome-icon>
            <a :href="`mailto:${cv.email}`" class="link" target="_blank">
                {{cv.email}}
            </a>
        </p>
        <p class="separator"></p>
        <p class="">
            <a :href="cv.linkedin" target="_blank" class="link">
                <font-awesome-icon class="subtitle icon"
                                   :icon="['fab', 'linkedin']"></font-awesome-icon>
                LinkedIn
            </a>
        </p>
    </div>
</template>

<script>
    export default {
        name: "Contact",
        props: [
            'strings',
            'cv'
        ]
    }
</script>

<style scoped>

</style>
